import Button from "@components/Button";
import Image from "@components/Image";
import ImagesGallery2 from "@components/ImagesGallery/ImagesGallery2";
import Icons from "@gstyles/styleguide/icons";
import { useRouteContext } from "@providers/RouteProvider";
import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import React from "react";
import styles from "./Facilities.module.scss";
import _ from "lodash";
interface IProps {
  [key: string]: any;
}

export default function MainItem({ item }: IProps) {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  const images: any = _.compact(_.get(item, "images"));
  return (
    <div className={cx(styles.mainItem)}>
      {!!(_.get(images, "length") === 1) && (
        <Image
          scale={1}
          speed={0}
          wrapperProps={{
            className: cx(styles.image),
          }}
          src={_.get(images, "0.src")}
          alt={_.get(images, "0.alt")}
          layout="fill"
          objectFit="cover"
        />
      )}
      {!!(_.get(images, "length") > 1) && (
        <ImagesGallery2
          itemClassName={styles.featuredImageItem}
          imageClassName={styles.featuredImage}
          galleryName={"slide-banner"}
          images={images}
        />
      )}
      <div className={cx(styles.infoSection)}>
        <div className={cx(styles.headingTab)}>
          <div className={cx(styles.nameTab, styles.active)}>
            <div className={cx(styles.title)}>{item.title}</div>
          </div>
        </div>
        <div className="block">
          <div className={cx(styles.content)}>{item.content}</div>
          {!!item?.shouldEnquire && (
            <Button
              type="icon"
              suffix="shape-arrow"
              className={cx(styles.enquireBtn)}
              label={i18n.t("Button.makeAnEnquire")}
              onClick={() => router.push("contact")}
            />
          )}
          <div className={cx(styles.moreInfoSection)}>
            <div className={cx(styles.moreInfoItemSection)}>
              <div className={cx(styles.label)}>{i18n.t("Wellness.hours")}</div>
              <div className="flex items-center">
                <Icons name="clock-outline" className={cx(styles.icon)} />
                <div className={cx(styles.iconContent)}>
                  {item.moreInfo.time}
                </div>
              </div>
            </div>
            <div className={cx(styles.moreInfoItemSection)}>
              <div className={cx(styles.label)}>
                {i18n.t("Wellness.reservations")}
              </div>
              <div className="flex items-center">
                <Icons name="phone-outline" className={cx(styles.icon)} />
                <div className={cx(styles.iconContent)}>
                  {item.moreInfo.phone}
                </div>
              </div>
            </div>
            <div className={cx(styles.moreInfoItemSection)}>
              <div className={cx(styles.label)}>
                {i18n.t("Wellness.location")}
              </div>
              <div className="flex items-center">
                <Icons
                  name="location-marker-outline"
                  className={cx(styles.icon)}
                />
                <div className={cx(styles.iconContent)}>
                  {item.moreInfo.floor}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
